import React, { useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useNotificationUIContext } from "../../NotificationUIContext";
import { initialFilter } from "../../NotificationUIHelpers";
import AsyncSelect from "react-select/async";
import { genOptionLoaderParams } from "../../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../../_redux/organization/organizationCrud";

const prepareFilter = (queryParams, values) => {
  const { name, notif_message, organization_uuid } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.notif_message = notif_message ?? "";
  filter.organization_uuid = organization_uuid ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const NotificationFilter = ({ listLoading }) => {
  // Notification UI Context
  const notificationUIContext = useNotificationUIContext();
  const notificationUIProps = useMemo(() => {
    return {
      setQueryParams: notificationUIContext.setQueryParams,
      queryParams: notificationUIContext.queryParams,
      filterType: notificationUIContext.filterType
    };
  }, [notificationUIContext]);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      notificationUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, notificationUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      notificationUIProps.setQueryParams(newQueryParams);
    }
  };

  const [currentTimeout, setCurrentTimeout] = useState(null);

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            {/* <div className="col-lg-4">
              <label htmlFor="name">Nama</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Nama Folder"
                onBlur={handleBlur}
                value={values.name}
                onChange={e => {
                  setFieldValue("name", e.target.value);
                }}
              />
            </div> */}
            <div className="col-lg-4">
              <label htmlFor="name">Organisasi</label>
              <AsyncSelect
                name="organization_uuid"
                loadOptions={genOptionLoaderParams(
                  inputValue =>
                    findorganization({
                      page1umber: 1,
                      pageSize: 50,
                      filter: { name: inputValue }
                    }),
                  ({ name, uuid }) => ({
                    label: name ?? "",
                    value: uuid ?? ""
                  }),
                  currentTimeout,
                  setCurrentTimeout
                )}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("organization_uuid", value);
                  } else {
                    setFieldValue("organization_uuid", "");
                  }
                }}
              />
            </div>
            <div className="col-lg-4">
              <label htmlFor="name">Message</label>
              <textarea
                className="form-control"
                name="notif_message"
                placeholder="Message.."
                onBlur={handleBlur}
                value={values.notif_message}
                onChange={e => {
                  setFieldValue("notif_message", e.target.value);
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
